module.exports = __webpack_public_path__ + "img/bannerText.e08743f0.png";